<template>
    <el-dialog title="煤源数据分享" :visible="visible" :show="show" width="80%" :close-on-click-modal="false"  @close="close"  height="60%" custom-class="module-dialog">
        <el-button type="primary" @click="addRow" >添加</el-button>
        <el-table class="tables"    :data="dataList" border stripe style="width: 100%;height:500px" >
            <el-table-column label="索引"  type="index" width="50" fixed ></el-table-column>
            <el-table-column align="center"   label="公司名称" fixed width="180">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.companyId" @change="chooseCompany(scope.row.companyId,scope.$index)" placeholder="请选择公司" filterable>
                        <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" prop="addPersonName"  label="创建人" fixed width="180"></el-table-column>-->
            <el-table-column align="center" prop="cocalName"  label="煤炭名称" fixed width="200"></el-table-column>
            <el-table-column align="center" prop="hots"  label="热值" ></el-table-column>
            <el-table-column align="center" prop="liufen"  label="硫分"></el-table-column>
            <el-table-column align="center" prop="unitPrice"  label="含税单价"  width="130"></el-table-column>
            <el-table-column align="center" prop="isBroken"  label="是否破碎"></el-table-column>
            <el-table-column align="center" prop="stock"  label="库存"></el-table-column>


          <el-table-column width="100" align="center"
                             header-align="center"  fixed="right"
                             label="操作">
                <template slot-scope="scope">
                    <el-button  type="danger" icon="el-icon-delete" size="mini" @click="removeRow(scope.$index)">移除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
            <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
            <el-button class="btn close" @click="close()">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initCompanyList();
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){

            return{
                stationList:[],
                updateBtn:true,
                url:base.get().url,
                visible:false,
                dataList:[],
                companyList:[],
            }
        },
        methods:{

            close(){
                this.updateBtn = true;
                this.dataList = [];
                this.stationList = [];
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                let checkFlag = true;
                /*this.dataList.map(item=>{
                    if(item.companyId==null){
                        this.$message.error("请选择公司");
                        checkFlag = false;
                    }
                    if (item.hsPrice==null || item.hsPrice == ''){
                        this.$message.error("请输入含税运费");
                        checkFlag = false;
                    }
                    if (item.bhsPrice==null || item.bhsPrice == ''){
                        this.$message.error("请输入不含税运费");
                        checkFlag = false;
                    }
                    if (item.arriveStation==null || item.arriveStation == ''){
                        this.$message.error("请选择到场地");
                        checkFlag = false;
                    }
                });*/
                if (checkFlag){
                    let cocalData = JSON.stringify(this.dataList);
                    this.$http({
                        url: this.url+`cocalTemplate/`+"cocalShare",
                        method:"post",
                        data:cocalData
                    }).then(res=>{
                        if(res.data.code==0){
                            this.$message.success(res.data.msg);
                        }
                    })
                }
            },
            chooseCompany(companyId,index){
                this.dataList[index].cocalName = this.rowData.cocalName;
                this.dataList[index].hots = this.rowData.hots;
                this.dataList[index].liufen = this.rowData.liufen;
                this.dataList[index].unitPrice = this.rowData.unitPrice;
                this.dataList[index].isBroken = this.rowData.isBroken;
                this.dataList[index].cocalId = this.rowData.id;
                // this.loadStationList(companyId,index);
                //this.dataList[index].arriveStation = this.rowData.arriveStation;
            },
            removeRow(index){
                this.dataList.splice(index,1);
            },

            initCompanyList(){
                let params = {'companyType':'1','isDelete':'0'};
                this.$http({
                    url: this.url+`company/`+"list",
                    method: "get",
                    params:params
                }).then(res=>{
                    if(res.data.code===0){
                        this.companyList = res.data.data;
                    }
                })
            },
            loadStationList(companyId,index){
                let companyObj ={};
                this.companyList.map(item=>{
                    if (item.id==companyId){
                        companyObj = item;
                    }
                })
                console.log(companyObj);
                this.stationList[index] = companyObj.sysorgList;
            },
            addRow(){
                let obj = {};
                this.dataList.push(obj);
            }
        },





    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
</style>